import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import NotFound from "./404";
import Dashboard from "./Dashboard";

import Profile from "./Profile";
import Login from "./Login";
import { GoogleOAuthProvider } from '@react-oauth/google';

import AdminRouter from "./admin/AdminRouter";
import appConfig from "./../config/appConfig";
import APIEndPoint from "./api-endpoint";


import PrivateRoute from "./PrivateRoute";
import TermsConditions from "./TermsConditions";
import PrivacyPolicy from "./PrivacyPolicy";
import PublicTiers from "./PublicTiers";
import CheckoutRouter from "./checkout/CheckoutRouter";
import AccountRouter from "./account/AccountRouter";
import AffiliateRouter from "./affiliate/AffiliateRouter";
import AffiliateLanding from "./affiliate/AffiliateLanding";
// pixalab-ai/src/pages/
export default function MainRoutes() {
    return (
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route path="/" element={<Login pageTitle={appConfig.pageTitle("Sign in")} />} />
                        <Route path="/login" element={<Login pageTitle={appConfig.pageTitle("Sign in")} />} />
                        <Route path="/terms-conditions" element={<TermsConditions pageTitle={appConfig.pageTitle("Terms & Conditions")} />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy pageTitle={appConfig.pageTitle("Privacy Policy")} />} />
                        <Route path="/pricing" element={<PublicTiers pageTitle={appConfig.pageTitle("Pricing")} />} />
                        <Route path="/tiers" element={<PublicTiers pageTitle={appConfig.pageTitle("Pricing")} />} />
                        <Route path="/affiliate-program" element={<AffiliateLanding pageTitle={appConfig.pageTitle("Affiliate Program")} />} />
                        <Route path="/dashboard" element={<PrivateRoute allowedRoles={['user','teamMember','client','affiliate']}> <Dashboard  pageTitle={appConfig.pageTitle("Dashboard")}/></PrivateRoute>} />
                        <Route path="/account-settings" element={<PrivateRoute allowedRoles={['user','admin','teamMember','client','affiliate']}> <Profile  pageTitle={appConfig.pageTitle("Account settings")}/></PrivateRoute>} />
                        <Route path="/admin/*" element={<PrivateRoute allowedRoles={['admin']}> <AdminRouter/></PrivateRoute>} />
                        <Route path="/checkout/*" element={<PrivateRoute allowedRoles={['user','admin','teamMember','client','affiliate']}> <CheckoutRouter/></PrivateRoute>} />
                        <Route path="/account/*" element={<PrivateRoute allowedRoles={['user','admin','teamMember','client','affiliate']}> <AccountRouter/></PrivateRoute>} />
                        <Route path="/affiliate/*" element={<PrivateRoute allowedRoles={['user','admin','teamMember','client','affiliate']}> <AffiliateRouter/></PrivateRoute>} />
                        <Route path="/api-endpoint" element={<PrivateRoute allowedRoles={['user','admin']} apiendpoint={true}> <APIEndPoint/></PrivateRoute>} />
                        <Route path="*" element={<PrivateRoute allowedRoles={['user','admin']}> <NotFound pageTitle={appConfig.pageTitle("Page not found")}/></PrivateRoute>} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </GoogleOAuthProvider>
    );
}
